import { toTeamStaffTO, type TeamStaffTO } from './Staff';

export interface TeamTO {
  id: number;
  active: boolean;
  address?: string;
  clinicName: string;
  features?: object;
  organisationUnit: string;
  parentClinicId: number;
  staffs: TeamStaffTO[];
}

export const toTeamTO = (teamRawData: any): TeamTO => ({
  id: teamRawData.id,
  active: teamRawData.active,
  address: teamRawData.address ?? null,
  clinicName: teamRawData.clinic_name,
  features: teamRawData.features ?? null,
  organisationUnit: teamRawData.organisation_unit,
  parentClinicId: teamRawData.parent_clinic_id,
  staffs: teamRawData.staff
    ? teamRawData.staff.map((staff: any) => toTeamStaffTO(staff))
    : [],
});
